import React from 'react';
import { Box, Grid, Button, Typography } from '@mui/material';
import { AddIcon } from 'icons/materialIcons';

const TeamSubteamsNavbar = ({ subteamsCount = 2, onAddSubteamSelect }) => {

    return (
        <Box sx={{ padding: '1rem' }}>
            {/* First Row: Title and Add Subteam Button */}
            <Grid container spacing={2} alignItems="center" sx={{ marginBottom: '1rem' }}>
                {/* Left Side - Title */}
                <Grid item xs={12} sm="auto">
                    <Typography variant="h6" sx={{ fontWeight: 500 }}>
                        Subteams{' '}
                        <Typography component="span" variant="body2" sx={{ fontWeight: 400, color: '#757575' }}>
                            ({subteamsCount})
                        </Typography>
                    </Typography>
                </Grid>

                {/* Right Side - Add Subteam Button */}
                <Grid item xs={12} sm container justifyContent="flex-end">
                    <Grid container spacing={1} justifyContent="flex-end">
                        {/* Add Subteam Button */}
                        <Grid item>
                            <Button
                                variant="contained"
                                onClick={onAddSubteamSelect}
                                startIcon={<AddIcon />}
                                sx={{
                                    backgroundColor: '#000',
                                    color: '#fff',
                                    fontWeight: '500',
                                    borderRadius: '0.5rem',
                                    textTransform: 'none',
                                    '&:hover': {
                                        backgroundColor: '#333',
                                    },
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                Add Subteam
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default TeamSubteamsNavbar;

